import { extendTheme } from "@chakra-ui/react"
import "focus-visible/dist/focus-visible"

import styles from "./styles"

import {
  InputTypes,
  Container,
  Divider,
  Heading,
  Button,
  Text,
  Link,
  List,
} from "./components"

import {
  breakpoints,
  fontWeights,
  fontSizes,
  presets,
  colors,
  fonts,
} from "./foundations"

const { Input, Textarea, Select } = InputTypes

const overrides = {
  config: { initialColorMode: "dark", useSystemColorMode: false },
  ...presets,

  components: {
    Container,
    Textarea,
    Heading,
    Divider,
    Button,
    Select,
    Input,
    Text,
    Link,
    List,
  },

  breakpoints,
  fontWeights,
  fontSizes,
  styles,
  colors,
  fonts,
}

export default extendTheme(overrides)
